import ApiService from 'app/services/ApiService';


export const FETCH_DAILY_COMPLIANCE_REQUEST = 'FETCH_DAILY_COMPLIANCE_REQUEST';
export const FETCH_DAILY_COMPLIANCE_SUCCESS = 'FETCH_DAILY_COMPLIANCE_SUCCESS';
export const FETCH_DAILY_COMPLIANCE_FAILURE = 'FETCH_DAILY_COMPLIANCE_FAILURE';
export const EXPORT_DAILY_COMPLIANCE_REQUEST = 'EXPORT_DAILY_COMPLIANCE_REQUEST';
export const EXPORT_DAILY_COMPLIANCE_SUCCESS = 'EXPORT_DAILY_COMPLIANCE_SUCCESS';
export const EXPORT_DAILY_COMPLIANCE_FAILURE = 'EXPORT_DAILY_COMPLIANCE_FAILURE';

export const SAVE_FILTER = 'SAVE_FILTER';
export const SAVE_PAGINATION = 'SAVE_PAGINATION';
export const CLEAR_REDUCER = 'CLEAR_REDUCER';

export const fetchDailyCompliance = (param) => dispatch => {
    let objValidate = {}

    for (const [key, value] of Object.entries(param)) {
        if (value) {
            objValidate[key] = value
        }
    }
    
    dispatch({ type: FETCH_DAILY_COMPLIANCE_REQUEST });
    ApiService.fetchDailyCompliance(objValidate).then(
        response => {
            dispatch({
                type: FETCH_DAILY_COMPLIANCE_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => dispatch({ type: FETCH_DAILY_COMPLIANCE_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message })
    )
}

export const exportXls = (param) => dispatch => {
    let objValidate = {}

    for (const [key, value] of Object.entries(param)) {
        if (value) {
            objValidate[key] = value
        }
    }

    dispatch({ type: EXPORT_DAILY_COMPLIANCE_REQUEST });
    ApiService.exportCompliance(objValidate).then(
        result => {
            const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            downloadFile(blob, "CumplimientoDiarioCapacitacion.xlsx");

            dispatch({ type: EXPORT_DAILY_COMPLIANCE_SUCCESS });
        }
    ).catch(
        (error) => dispatch({ type: EXPORT_DAILY_COMPLIANCE_FAILURE, payload: error.message })
    )
}
export const clear = () => ({
    type: CLEAR_REDUCER
});

export const saveFilter = (filter) => ({
    type: SAVE_FILTER,
    payload: filter
});

export const savePagination = (pagination) => ({
    type: SAVE_PAGINATION,
    payload: pagination
});

const downloadFile = (blob, fileName) => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
};